import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";
import moment from "moment";
import { useEffect, useMemo } from "react";

import { useInternalBankHistory } from "../apis";

const useInternalBankHistoryList = (dateRange: [Date, Date]) => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = useMemo(
    () => ({
      page,
      take: GET_LIST_REQUEST_DEFAULT_LIMIT,
      search: debouncedSearch,
      orderBy: sorting[0]?.id ?? null,
      order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : "DESC",
      from: moment(dateRange[0]).format("YYYY-MM-DD"),
      to: moment(dateRange[1]).format("YYYY-MM-DD")
    }),
    [page, debouncedSearch, sorting, dateRange]
  );

  const { history, meta, isLoading } = useInternalBankHistory(requestParams);

  useEffect(() => {
    setPage(1);
  }, [dateRange]);

  return {
    history,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  };
};

export default useInternalBankHistoryList;
